import { useTranslation } from 'react-i18next';

export default function Method() {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      titleKey: 'method.paso1.titulo',
      descriptionKey: 'method.paso1.descripcion',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      titleKey: 'method.paso2.titulo',
      descriptionKey: 'method.paso2.descripcion',
      icon: 'ri-draft-line'
    },
    {
      number: '03',
      titleKey: 'method.paso3.titulo',
      descriptionKey: 'method.paso3.descripcion',
      icon: 'ri-money-euro-circle-line'
    },
    {
      number: '04',
      titleKey: 'method.paso4.titulo',
      descriptionKey: 'method.paso4.descripcion',
      icon: 'ri-tools-line'
    },
    {
      number: '05',
      titleKey: 'method.paso5.titulo',
      descriptionKey: 'method.paso5.descripcion',
      icon: 'ri-line-chart-line'
    }
  ];

  return (
    <section id="metodo" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            {t('method.titulo')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('method.subtitulo')}
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-teal-200 via-teal-400 to-teal-200"></div>

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`flex flex-col lg:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                  <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100 relative">
                    <div className="relative z-10">
                      <div className={`flex items-center gap-4 mb-3 ${index % 2 === 0 ? 'lg:justify-end' : ''}`}>
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-teal-100 rounded-2xl flex-shrink-0">
                          <i className={`${step.icon} text-2xl text-teal-600`}></i>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900">
                          {t(step.titleKey)}
                        </h3>
                      </div>
                      <p className="text-gray-600 leading-relaxed">
                        {t(step.descriptionKey)}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="relative z-10 flex-shrink-0">
                  <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center shadow-lg border-4 border-white">
                    <span className="text-white font-bold text-lg">{step.number}</span>
                  </div>
                </div>

                <div className="flex-1 hidden lg:block"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-teal-50 to-teal-100 rounded-2xl p-8 max-w-3xl mx-auto">
            <a 
              href="#oferta"
              className="bg-teal-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-teal-700 transition-colors duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-block"
            >
              {t('hero.ctaEstudio')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
